{
	"cs-CZ": {},
	"da-DK": {},
	"de-DE": {},
	"en-GB": {},
	"en-UK": {},
	"en-US": {},
	"en-ZZ": {},
	"es-ES": {},
	"et-EE": {},
	"fi-FI": {},
	"fr-FR": {},
	"hu-HU": {},
	"is-IS": {},
	"it-IT": {},
	"ja-JP": {},
	"ko-KR": {},
	"nb-NO": {},
	"nl-NL": {},
	"pl-PL": {},
	"pt-BR": {},
	"pt-PT": {},
	"ro-RO": {},
	"ru-RU": {},
	"sk-SK": {},
	"sv-SE": {},
	"tr-TR": {},
	"zh-CN": {},
	"zh-TW": {}
}
